export default {
  sm: `
    햇빛을 가려주는 루버
  `,
  md: `
    햇빛을 가려주는 
    루버
  `
};
